import type { ComponentType, SVGProps } from 'react';

import { ReactComponent as AddCommentIcon } from '../../react-icons/map-controls/add-comment.svg';
import { ReactComponent as CommentListIcon } from '../../react-icons/map-controls/comment-list.svg';
import { ReactComponent as CommentsIcon } from '../../react-icons/map-controls/comments.svg';
import { ReactComponent as HighlightIcon } from '../../react-icons/map-controls/highlight.svg';
import { ReactComponent as LadderIcon } from '../../react-icons/map-controls/ladder.svg';
import { ReactComponent as MeasureIcon } from '../../react-icons/map-controls/measure.svg';
import { ReactComponent as OptimizeRouteIcon } from '../../react-icons/map-controls/optimize-route.svg';
import { ReactComponent as OrientationIcon } from '../../react-icons/map-controls/orientation.svg';
import { ReactComponent as PlayerIcon } from '../../react-icons/map-controls/player.svg';
import { ReactComponent as RelatedFilesIcon } from '../../react-icons/map-controls/related-files.svg';
import { ReactComponent as SimpleLineIcon } from '../../react-icons/map-controls/simple-line.svg';
import { ReactComponent as SpeedIcon } from '../../react-icons/map-controls/speed.svg';
import { ReactComponent as StatsIcon } from '../../react-icons/map-controls/stats.svg';
import { ReactComponent as TacksIcon } from '../../react-icons/map-controls/tacks.svg';
import { ReactComponent as TacticalIcon } from '../../react-icons/map-controls/tactical.svg';

export type MapControlIconName =
  | 'player'
  | 'comments'
  | 'commentList'
  | 'addComment'
  | 'measure'
  | 'optimize'
  | 'highlight'
  | 'tacks'
  | 'ladder'
  | 'orientation'
  | 'plain'
  | 'speed'
  | 'tactical'
  | 'stats'
  | 'relatedFiles';

type SvgIconComponent = ComponentType<SVGProps<SVGSVGElement>>;

const MAP_CONTROL_ICONS: Record<MapControlIconName, SvgIconComponent> = {
  addComment: AddCommentIcon,
  commentList: CommentListIcon,
  comments: CommentsIcon,
  highlight: HighlightIcon,
  ladder: LadderIcon,
  measure: MeasureIcon,
  optimize: OptimizeRouteIcon,
  orientation: OrientationIcon,
  plain: SimpleLineIcon,
  player: PlayerIcon,
  relatedFiles: RelatedFilesIcon,
  speed: SpeedIcon,
  stats: StatsIcon,
  tacks: TacksIcon,
  tactical: TacticalIcon,
};

type MapControlIconProperties = Omit<SVGProps<SVGSVGElement>, 'name'> & {
  name: MapControlIconName;
};

export function MapControlIcon({ name, className, ...properties }: MapControlIconProperties) {
  const Icon = MAP_CONTROL_ICONS[name];
  const classes = ['map-tool-icon', className].filter(Boolean).join(' ');

  return (
    <Icon
      aria-hidden="true"
      focusable="false"
      className={classes}
      {...properties}
    />
  );
}
